import { ConsoleRequest, DataProviderType } from '../../../../utils/request';
import { ComplexSuggestedItem } from '../../../../ui/gzComplexEnumList/types';
import { GzCompanyFilterWebComponent } from '../../../../ui/gzCompanyFilter';
import { SelectedOption } from '../../../../ui/gzEnumList/types';
import { GzSingleSelectComplexWebComponent } from '../../../../ui/gzSingleSelectComplex';
import { getCompanyExtraFilterForComplexEnumFilterCallback } from '../../../common/utils';

export class RiskManagementUsernames {
  /**
   *
   * @param page
   * @param limit
   * @param searchString
   * @param filters
   * @protected
   */
  static async getRemoteData(page, limit, searchString: string = '', filters: Array<any> = []): Promise<Array<any>> {
    return await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.CORE,
      endpoint: 'RiskManagementUsers',
      method: 'getUsernames',
      payload: {
        page,
        limit,
        searchString,
        filters,
      },
    });
  }

  /**
   *
   * @param response
   * @protected
   */
  static convertResponse(response): ComplexSuggestedItem[] {
    return response;
  }

  static getExtraFilters(): Array<any> {
    return getCompanyExtraFilterForComplexEnumFilterCallback('gz-users-app');
  }
}
